var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import loadScripts from '../../utils/loadScript';
import { LOGGER_NAME, WHATFIX_URL } from './constants';
import logger from '../../config/app.logger';
//@ts-ignore
import { isValidUrl } from '@mindtickle/utils';
import { getExtendedLogger } from '../Logger';
import { isAdminSite } from '../../utils';
var log = getExtendedLogger(LOGGER_NAME, logger);
export function loadWhatfix(whatfixConfig) {
    var whatfixLearnerUrl = isValidUrl(whatfixConfig === null || whatfixConfig === void 0 ? void 0 : whatfixConfig.learnerUrl)
        ? whatfixConfig === null || whatfixConfig === void 0 ? void 0 : whatfixConfig.learnerUrl : WHATFIX_URL.LEARNER;
    var whatfixAdminUrl = isValidUrl(whatfixConfig === null || whatfixConfig === void 0 ? void 0 : whatfixConfig.adminUrl)
        ? whatfixConfig === null || whatfixConfig === void 0 ? void 0 : whatfixConfig.adminUrl : WHATFIX_URL.ADMIN;
    var whatfixUrl = isAdminSite() ? whatfixAdminUrl : whatfixLearnerUrl;
    if (!whatfixUrl) {
        log('Whatfix URL is not provided. Skipping loading');
        throw new Error('Whatfix URL is not provided');
    }
    log('loading Whatfix');
    // Returns a promise when script is loaded
    return loadScripts({ url: whatfixUrl, defer: true });
}
export function setWhatfixVariables(variables) {
    if (window.MTWhatfixVariables) {
        window.MTWhatfixVariables = __assign(__assign({}, window.MTWhatfixVariables), variables);
    }
    else {
        window.MTWhatfixVariables = variables;
    }
    log("variables set successfully");
}
//# sourceMappingURL=helpers.js.map